import { HydrationBoundary, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import getQueryClient from "@/utils/getQueryClient";

interface TanStackQueryProviderProps extends React.PropsWithChildren {
  dehydratedState: Record<string, unknown>;
}

const TanStackQueryProvider = (props: TanStackQueryProviderProps) => {
  const { children, dehydratedState } = props;
  /*
    NOTE: Avoid useState when initializing the query client if you don't
    have a suspense boundary between this and the code that may
    suspend because React will throw away the client on the initial
    render if it suspends and there is no boundary
  */
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default TanStackQueryProvider;
